import Icon1 from "../../../images/process/pencil-ruler.png";
import Icon2 from "../../../images/process/indent.png";
import Icon3 from "../../../images/process/laptop.png";
import Icon4 from "../../../images/process/leanpub.png";

export const Steps = [
  {
    icon: Icon1,
    step: "Step 1",
    process: "Enroll yourself",
  },
  {
    icon: Icon2,
    step: "Step 2",
    process: "Explore your interests",
  },
  {
    icon: Icon3,
    step: "Step 3",
    process: "Select your internship",
  },
  {
    icon: Icon4,
    step: "Step 4",
    process: "Learn and Implement",
  },
];

export const StepsInShort = [
  "8 weeks",
  "Internship Certificate",
  "Industry Level Project",
];
